(function(){

  'use strict';

  function plural() {
    return function (packages, str) {
      var pckgs = packages || [];
      var len = pckgs.length;

      function setPlural(str) {

        var strLen = str.split(' '),
            plural = [];

          for (var i = 0; i < strLen.length; i++) {
            plural.push(strLen[i] + 's');
          }

          return plural.toString().replace(/\,/g,' ');

      }

      if(len > 0) {
        return len > 1 ? len + ' ' + setPlural(str) : len + ' ' + str;
      } else {
        return str;
      }

    };
  }

  angular
  .module('mandaeApp')
  .filter('plural', plural);

}());
